export const environment = {
  postgrestBaseUrl: 'https://servreg.e2e3.desp.space/api',
  fileSystemBaseUrl: 'https://servreg.e2e3.desp.space/fs/serviceMedia',
  fileSystemMediaBaseUrl: 'https://servreg.e2e3.desp.space/fs/generalMedia',
  fileSystemDocBaseUrl: 'https://servreg.e2e3.desp.space/fs/docfiles',
  keycloakUrl: 'https://iam.e2e3.desp.space/',
  realm: 'desp',
  clientId: 'srvregbe_public',
  enableLogging: true,
  logsUrl: 'https://servreg.e2e3.desp.space/desp-servreg-logs'
};
